/**
 * @module lib/audience/datalayer/page
 */
import tgamConfig from "config/tgam";
import { getUrlVars } from "utils/urls";
import { get as getReferrer } from "lib/audience/referrer";

/**
 * @method pageReferrer
 * @description The referring page. Expects traffic shaping from Test & Target
 * to have a ?ref param and will report that value as referrer.
 * Currently on production there is an ESI call that gets server
 * side referrer info since it's not particularly reliable on the client.
 * @returns {Object}
 */
const pageReferrer = () => {
  const params = getUrlVars();
  if (params.ref) {
    return getReferrer(decodeURI(params.ref));
  }
  return getReferrer();
};

/**
 * @description collects all data-page-topics on the current page
 * @returns {String[]|null}
 */
const topics = () => {
  const pageTopicsEl = document.querySelector("[data-page-topics]");
  if (!pageTopicsEl) {
    return null;
  }
  return pageTopicsEl.dataset.pageTopics.split(",");
};

// Commented "?" values, are set here: /inc/default/audience/datalayer/page.jsp
export function setup() {
  const api = {
    appview: tgamConfig.env.inAppView === true,
    // hierarchy: "?",
    // channel: "?",
    // name: "?",
    // url: "?",
    // type: "?",
    // number: "?",
    referrer: pageReferrer(),
    topics: topics()
    // amp: "?",
    // advContent: "?",
    // subsections: "?",
    // lastSection: "?"
  };
  return api;
}
